
const reviews_list = [
    {
        username: 'ABCCCCCCCCCCCCCCCCCCCCCCCc',
        profile_image: 'https://media.istockphoto.com/id/1437816897/photo/business-woman-manager-or-human-resources-portrait-for-career-success-company-we-are-hiring.jpg?s=612x612&w=0&k=20&c=tyLvtzutRh22j9GqSGI33Z4HpIwv9vL_MZw_xOE19NQ=',
        rating: 3,
        review: "This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good This product looks good ",

    },
    {
        username: 'ABC',
        profile_image: 'https://media.istockphoto.com/id/1437816897/photo/business-woman-manager-or-human-resources-portrait-for-career-success-company-we-are-hiring.jpg?s=612x612&w=0&k=20&c=tyLvtzutRh22j9GqSGI33Z4HpIwv9vL_MZw_xOE19NQ=',
        rating: 3,
        review: "This product looks good",

    },
    {
        username: 'ABC',
        profile_image: 'https://media.istockphoto.com/id/1437816897/photo/business-woman-manager-or-human-resources-portrait-for-career-success-company-we-are-hiring.jpg?s=612x612&w=0&k=20&c=tyLvtzutRh22j9GqSGI33Z4HpIwv9vL_MZw_xOE19NQ=',
        rating: 3,
        review: "This product looks good",

    },
    {
        username: 'ABC',
        profile_image: 'https://media.istockphoto.com/id/1437816897/photo/business-woman-manager-or-human-resources-portrait-for-career-success-company-we-are-hiring.jpg?s=612x612&w=0&k=20&c=tyLvtzutRh22j9GqSGI33Z4HpIwv9vL_MZw_xOE19NQ=',
        rating: 3,
        review: "This product looks good",

    },
    {
        username: 'ABC',
        profile_image: 'https://media.istockphoto.com/id/1437816897/photo/business-woman-manager-or-human-resources-portrait-for-career-success-company-we-are-hiring.jpg?s=612x612&w=0&k=20&c=tyLvtzutRh22j9GqSGI33Z4HpIwv9vL_MZw_xOE19NQ=',
        rating: 3,
        review: "This product looks good",

    },
]

export default reviews_list;